import React, {useState} from "react";

import "./RebootButton.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import Accordion from "react-bootstrap/Accordion";
import {sleep} from "../../../lib/utils";
import {faPowerOff, faRotate} from "@fortawesome/free-solid-svg-icons";

function RebootButton({bond}) {

    const [rebootStarted, setRebootStarted] = useState(false);
    const [rebootLabel, setRebootLabel] = useState(`Reboot`);

    async function startReboot() {
        setRebootStarted(true)
        await bond.put('/sys/reboot', {})
        await sleep(5000);
        while (true) {
            try {
                setRebootLabel("Awaiting")
                let response = await bond.get('/sys/version');
                if (!("fw_ver" in response)) throw new Error("Rebooting");
                setRebootStarted(false);
                setRebootLabel("Reboot")
                return;
            } catch {
                await sleep(2000);
            }
        }
    }

    return (
        <Accordion className="reboot-accordion">
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    <FontAwesomeIcon icon={faPowerOff} className="me-2" />
                    Reboot
                </Accordion.Header>
                <Accordion.Body>
                    <div className="d-grid gap-2">
                        <Button size={"lg"} className={"restartButton"} disabled={rebootStarted} variant={"outline-secondary"}
                                onClick={startReboot}>
                            <FontAwesomeIcon icon={rebootStarted ? faRotate : faPowerOff} size="xl"
                                             className={`me-4 ${rebootStarted ? "fa-spin" : ""}`}/>
                            {rebootLabel}
                        </Button>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}

export default RebootButton;


